
import { useContext, useEffect, useState, useCallback } from 'react'
import { store } from '../../App'
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Footer from './Footer';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'aos/dist/aos.css'; // Import AOS CSS
import CounterSection from '../CounterSection';
import AOS from 'aos';
import MyCarousel from './Carousel';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import parse from 'html-react-parser';

function Hompage() {
  const [menus, setMenus] = useContext(store);
  const [option, setOption] = useState();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countReached25, setCountReached25] = useState(false);

  // Initialize AOS
  useEffect(() => {
    AOS.init();
  }, []);

  // Timer to control when count reaches 25
  useEffect(() => {
    const timer = setTimeout(() => {
      setCountReached25(true);
    }, 5750); // Adjust this value according to your CountUp duration

    return () => clearTimeout(timer);
  }, []);

  // Fetching homepage data
  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get('https://admin.techno-elevators.com/api/getHomePageDataBySlug/home');
      setData(response.data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  if (loading) {
    return <div className='loader-header'>
    <span className="loader"></span>
    </div>;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Helmet>
  <title>Techno Elevators| Best Escalators & Elevators in Oman</title>
  <meta  name="description"   content="Techno Elevators provides the best and safest elevators and escalators for home, commercial & industrial purposes, along with comprehensive services. "
  />
  <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
  <link rel="canonical" href="https://www.techno-elevators.com/" />
</Helmet>


      <MyCarousel />
      {data && data.view_all_business_lines && (
        <section className="team spad mt-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="section-title mb-4">
                  <h1 className='mb-5'>{data.view_all_business_lines.category_title_en}</h1>
                </div>
              </Col>
            </Row>
            <Row>
              {data.view_all_business_lines?.sections?.map((item, index) => (
                <Col lg={4} md={4} data-aos="zoom-in-up" style={{ paddingLeft: "7px" }} key={index}>
                  <div
                    className="team__item set-bg"
                    style={{ backgroundImage: `url(${item.icon_file_or_image})` }}
                  >
                    <div className="team__text">
                      <div className="team__title">
                        <h5>{item.section_title_en}</h5>
                        <span>{item.section_sub_title_en}</span>
                      </div>
                      <div>{parse(item.description_en)}</div>
                      <div className="team__social">
                        <a href="#"><i className="fa fa-facebook"></i></a>
                        <a href="#"><i className="fa fa-twitter"></i></a>
                        <a href="#"><i className="fa fa-instagram"></i></a>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      {/* Our Specialization Section */}
      <Container fluid>
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col lg={11}>
            <section className="services spad">
              <div className="container mb-4">
                <div className="row">
                  <div className="col-lg-12 mb-4">
                    <div className="section-title mt-5 mb-5">
                      <h1>{data?.our_specialization?.category_title_en}</h1>
                    </div>
                  </div>
                </div>
                <div className="row our_specialization">
                  {data?.our_specialization?.sections.map((item) => (
                    <div className="col-lg-3 col-md-6 col-sm-6" key={item.id}>
                      <Link to="elevators">
                        <div className="services__item text-center">
                          <img src={item.icon_file_or_image} alt="passenger elevators" width={'65px'} />
                          <h4 className='mt-1'>{item.section_title_en}</h4>
                          <div>{parse(item.description_en)}</div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>

      {/* Why Choose Us Section */}
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Row style={{ display: 'flex', justifyContent: 'center' }}>
              <Col lg={9}>
                <h3 className='text-center mt-4 mb-4'>{data?.why_choose_us?.category_title_en}</h3>
                {data?.why_choose_us?.sections.map((item) => (
                  <Accordion defaultActiveKey={item.id === 0} key={item.id}>
                    <Accordion.Item eventKey={item.id}>
                      <Accordion.Header>
                        <strong>{item.section_title_en}</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        {parse(item.description_en)}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Counter Section */}
      <section className="background-image mt-5" style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Container>
          <Row>
            <Col lg={12}>
              <CounterSection />
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default Hompage;






